var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8656 0.850457C18.0317 0.85268 17.3512 1.53641 17.3534 2.37032L17.3566 3.63976L1.89282 3.67924L1.96035 29.7087L34.1549 30.9705L35.0001 29.6232L34.9385 5.53609L34.9338 3.59425L34.9305 2.32481C34.9284 1.49089 34.2446 0.810344 33.4108 0.812566L18.8656 0.850457Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1.55665 18.2388C1.52712 18.4428 1.66799 18.6313 1.87194 18.6608L28.2204 22.4888C28.4244 22.5184 28.6129 22.3775 28.6424 22.1735C28.6424 22.1735 29.9511 3.84156 29.7472 3.81213L4.58261 3.65324e-05C4.37961 -0.0298103 1.55665 18.2388 1.55665 18.2388Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41015 0.375427L0.700195 19.0362L27.7862 22.9696L30.4961 4.30896L3.41015 0.375427Z",
    fill: "#BCEDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M28.1221 21.9674L28.2154 3.70765L1.86661 2.75287L1.55322 21.6065L28.1221 21.9674Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.313921 3.42212L0 22.276L27.3666 22.7318L27.6806 3.87776L0.313921 3.42212Z",
    fill: "#E6FFFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M18.5253 1.60778C17.6914 1.61 17.0108 2.29373 17.013 3.12764L17.0162 4.39708L1.55249 4.43656L1.6197 30.4652L34.1547 30.9675L34.5981 6.29331L34.5934 4.35157L34.5902 3.08213C34.588 2.24822 33.9042 1.56767 33.0703 1.56989L18.5253 1.60778Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0213 2.19775C17.1874 2.19998 16.5068 2.8837 16.509 3.71761L16.5123 4.98706L1.04883 5.02738L1.11608 31.056L34.1561 30.9714L34.0944 6.88424L34.0898 4.94239L34.0866 3.67295C34.0844 2.83904 33.4007 2.15859 32.5667 2.16071L18.0213 2.19775Z",
    fill: "#474747"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M24.6645 4.53292L34.1574 4.52889L24.6633 4.08606L24.6645 4.53292Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M34.1561 30.9714L1.04883 5.0274L1.11608 31.0561L34.1561 30.9714Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFolder);
export default __webpack_public_path__ + "static/media/blackFolder.f3a202de63a33c614f5c85ee56a3dbcc.svg";
export { ForwardRef as ReactComponent };